import { useState, useEffect } from 'react';
import { connectivityMonitor } from '@/services/offline';

export function useConnectivity() {
  const [isOnline, setIsOnline] = useState(connectivityMonitor.isOnline());
  const [isRecovering, setIsRecovering] = useState(connectivityMonitor.isRecovering());
  const [lastChecked, setLastChecked] = useState(new Date());

  useEffect(() => {
    const unsubscribe = connectivityMonitor.subscribe((online) => {
      setIsOnline(online);
      setIsRecovering(connectivityMonitor.isRecovering());
      setLastChecked(new Date());
    });

    return unsubscribe;
  }, []);

  return { isOnline, isRecovering, lastChecked };
}
